import { FC } from 'react';

import { Text } from '@mantine/core';
import { DatePickerInput, DatePickerInputProps } from '@mantine/dates';
import { useDisclosure } from '@mantine/hooks';

import { WorkTimeSelector } from '@/entities/WorkTimeSelector/WorkTimeSelector.tsx';

import { TDateRange } from '@/shared/types/app.types';
import IconClock from '@/shared/uikit/assets/icons/IconClock.svg?react';

import { Picker } from './Picker';
import classes from './RangeTimePicker.module.css';

type RangeTimePickerProps = {
	value: TDateRange;
	isTaxi?: boolean;
	isDefault?: boolean;
	onChange: (date: TDateRange) => void;
} & Omit<DatePickerInputProps, 'value' | 'onChange'>;

export const RangeTimePicker: FC<RangeTimePickerProps> = ({
	value,
	valueFormat = 'HH:mm',
	isTaxi = false,
	isDefault = false,
	onChange,
}) => {
	const [opened, { close: closeTimePicker, open: openTimePicker }] = useDisclosure(false);

	return (
		<>
			<DatePickerInput
				classNames={classes}
				onClick={openTimePicker}
				value={value}
				type="range"
				valueFormat={valueFormat}
				label={
					<Text c="#667085" fz={12} fw={500} lh="normal" tt="uppercase">
						Время
					</Text>
				}
				rightSection={<IconClock fontSize={18} />}
				placeholder="Не выбрано"
				radius="lg"
				readOnly
			/>
			{opened &&
				(isDefault ? (
					<WorkTimeSelector opened={opened} onClose={closeTimePicker} />
				) : (
					<Picker
						initValue={value}
						isTaxi={isTaxi}
						opened={opened}
						close={closeTimePicker}
						onChange={onChange}
					/>
				))}
		</>
	);
};
